/**
 * Conspiracy Board Adapter
 *
 * This module is responsible for adapting the data for the Conspiracy Board component.
 * It transforms the input data into the required format for the component.
 *
 * Dependencies:
 * - Logger for logging adapter events and errors.
 */

import { arraytoObj } from "../../helper/sb-fixer";
import { logAdapterEvent, logError } from "../../helper/logger";

interface IConspiracyBoardAdapter {
  content: any;
  componentId: string;
  index: number;
  cmsPageName?: string;
}

export const conspiracyBoardAdapter = ({
  content,
  componentId,
  index,
  cmsPageName
}: IConspiracyBoardAdapter): any => {
  const ADAPTER_NAME = "conspiracyBoardAdapter";
  try {
    logAdapterEvent(ADAPTER_NAME, "Adapting data for Conspiracy Board", {
      content,
      componentId,
      index,
      cmsPageName
    });

    return {
      props: {
        ...(Array.isArray(content?.marquee) ? arraytoObj(content) : content),
        id: componentId,
        aboveTheFold: index <= 2
      },
      type: "CONSPIRACYBOARD"
    };
  } catch (error) {
    logError(ADAPTER_NAME, error, {
      componentId,
      index,
      cmsPageName
    });
    // Return undefined or handle the error gracefully as per existing logic
  }
};

export default conspiracyBoardAdapter;
